import React, { useState, createElement } from 'react';
import { EyeIcon, EyeOffIcon, SparklesIcon } from 'lucide-react';
interface PasswordGateProps {
  onSuccess: () => void;
}
export function PasswordGate({
  onSuccess
}: PasswordGateProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'penguinsnacks11125') {
      localStorage.setItem('demo-authenticated', 'true');
      onSuccess();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };
  return <div className="min-h-screen w-full bg-gradient-to-br from-shell via-shell-light to-shell flex items-center justify-center p-6 relative overflow-hidden" data-id="element-321">
      {/* Subtle Background Decorations with Animation */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20" data-id="element-322">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse" style={{
        animationDuration: '4s'
      }} data-id="element-323" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-primary-hover/10 rounded-full blur-3xl animate-pulse" style={{
        animationDuration: '4s',
        animationDelay: '2s'
      }} data-id="element-324" />
      </div>
      {/* Centered Login Card with Scale-In Animation */}
      <div className="w-full max-w-md relative z-10" style={{
      animation: 'scaleIn 300ms cubic-bezier(0.34, 1.56, 0.64, 1)'
    }} data-id="element-325">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200" data-id="element-326">
          {/* Header with Logo */}
          <div className="bg-gradient-to-r from-primary to-primary-hover px-6 py-6 animate-slide-in-down" data-id="element-327">
            <div className="flex justify-center" data-id="element-328">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3NDjGZ2vruRi6kebMsUi4C/AgileBrain_Logo.png" alt="AgileBrain Logo" className="h-16 w-auto object-contain transition-transform duration-300 hover:scale-105" data-id="element-329" />
            </div>
          </div>
          {/* Form Content */}
          <div className="px-6 py-6" style={{
          animation: 'fadeIn 300ms cubic-bezier(0.4, 0, 0.2, 1) 100ms'
        }} data-id="element-330">
            <div className="mb-6" data-id="element-331">
              <div className="flex items-center justify-between mb-4" data-id="element-332">
                <h1 className="text-xl font-bold text-gray-900" data-id="element-333">
                  Welcome Back
                </h1>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-334">
                Enter password to access demo platform.
              </p>
            </div>
            <form onSubmit={handleSubmit} data-id="element-335">
              <div className="mb-5" data-id="element-336">
                <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-337">
                  Access Password
                </label>
                <div className="relative" data-id="element-338">
                  <input type={showPassword ? 'text' : 'password'} id="password" value={password} onChange={e => setPassword(e.target.value)} className={`w-full px-4 py-2.5 border-2 rounded-lg transition-all duration-200 text-base text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary ${error ? 'border-red-300 bg-red-50 focus:ring-red-200 animate-shake' : 'border-gray-200'}`} placeholder="Enter password" autoFocus data-id="element-339" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-all duration-200 p-2 rounded-lg hover:bg-gray-100 hover:scale-110 active:scale-95" aria-label={showPassword ? 'Hide password' : 'Show password'} data-id="element-340">
                    {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-341" /> : <EyeIcon className="w-5 h-5" data-id="element-342" />}
                  </button>
                </div>
                {error && <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg animate-slide-in-down" data-id="element-343">
                    <p className="text-red-700 text-sm font-medium" data-id="element-344">
                      Incorrect password. Please try again.
                    </p>
                  </div>}
              </div>
              <button type="submit" className="w-full px-4 py-2.5 bg-primary text-white rounded-lg font-semibold hover:bg-primary-hover active:bg-primary-pressed transition-all duration-200 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 hover:scale-102 active:scale-98" data-id="element-345">
                Access Demo
              </button>
            </form>
          </div>
          {/* Footer with Branding */}
          <div className="px-6 py-4 bg-gradient-to-br from-gray-50 to-primary-50 border-t border-gray-200" style={{
          animation: 'fadeIn 300ms cubic-bezier(0.4, 0, 0.2, 1) 200ms'
        }} data-id="element-346">
            <div className="text-center space-y-2" data-id="element-347">
              <div className="flex items-center justify-center gap-2 opacity-60" data-id="element-348">
                <SparklesIcon className="w-3.5 h-3.5 text-primary animate-pulse" data-id="element-349" />
                <span className="text-xs text-gray-500 font-mono tracking-tight" data-id="element-350">
                  Q4 2025 Demo Version 0.4
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
// Add shake animation for error state
const shakeKeyframes = `
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}
.animate-shake {
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97);
}
`;
// Inject shake animation
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = shakeKeyframes;
  document.head.appendChild(style);
}